import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-down"><path d="M18.25 14L12 20.25L5.75 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 19.5V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowDown;
